import React from "react";
import { Menu, message, Modal } from "antd";
import isEmpty from "lodash/isEmpty";
import startsWith from "lodash/startsWith";
import WeaCollect from "@WeaCollect";
// import WeaCollect from "../wea-collect/ro";
import WeaNewScroll from "../wea-new-scroll";
import { callApi } from "../wea-tools/callApi";
import { ls } from "../wea-tools/storage";
import Base64 from "../wea-tools/base64";
import { getLabel } from "../wea-locale-provider/util";
// import SensitiveDialog from "./SensitiveDialog";
// import SensitiveDialog from "@SensitiveDialog";
import ShowUrl from "@WeaShowUrl";
import classNames from "classnames";

const confirm = Modal.confirm;
const Item = Menu.Item;
const SubMenu = Menu.SubMenu;

class RightMenu extends React.Component {
  static displayName = "RightMenu";
  static defaultProps = {
    datas: [],
    collectParams: undefined,
    helpParams: {},
    scrollNum: 13
  };
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    this.state = {
      collectVisable: false,
      urlVisible: false,
      // showUrlItem: false,
      maskClose: this.props.maskClose || false,
      sensitiveVisible: false,
      sensitiveWordFeedback: 0
    };
  }
  componentDidMount() {
    const { showReport } = this.props;
    // callApi("/api/ec/dev/app/getUserInfo", "GET").then(res => {
    //   const { isAdmin, userid } = res;
    //   this.setState({ showUrlItem: res.isAdmin });
    // });
    if (showReport && !("sensitiveWordFeedback" in window)) {
      callApi("/api/sensitive/getSensitiveWordFeedback", "GET").then(res => {
        if (res.status) {
          window.sensitiveWordFeedback = res.sensitiveWordFeedback;
          window.localStorage.setItem(
            "sensitiveWordFeedback",
            res.sensitiveWordFeedback
          );
          this.setState({ sensitiveWordFeedback: res.sensitiveWordFeedback });
        }
      });
    }
    this.instanceIsMounted = true;
  }
  componentWillUnmount() {
    this.instanceIsMounted = false;
  }
  onItemClick = (o, datas) => {
    datas.forEach((d, i) => {
      if (d.itemGroup && d.itemGroup.length) {
        d.itemGroup.forEach(g => {
          d.allowSelect &&
            g.key === o.key &&
            typeof g.onClick === "function" &&
            g.onClick(o.key, i);
        });
      } else {
        d.key === o.key && typeof d.onClick === "function" && d.onClick(o.key);
      }
    });
  };
  getMenuItemTitle = i => {
    if (i.title || (i.content && typeof i.content === "string")) {
      return i.title || i.content;
    }
    if (i.content && i.content.props) {
      if (i.content.props.title && typeof i.content.props.title === "string") {
        return i.content.props.title;
      }
      if (i.content.props.children) {
        if (typeof i.content.props.children === "string") {
          return i.content.props.children;
        } else if (
          i.content.props.children.props &&
          i.content.props.children.props.title
        ) {
          return i.content.props.children.props.title;
        }
      }
    }
  };
  getMenu = (datas, scrollNum, isScroll) => {
    const scrollHeight = datas.length > scrollNum ? scrollNum * 30 + 10 : false;
    if (isScroll && scrollHeight) {
      return (
        <WeaNewScroll
          ecId={`${this.props.ecId}_WeaNewScroll@a99n1j`}
          height={scrollHeight}
        >
          <Menu
            ecId={`${this.props.ecId}_Menu@ztwi9a`}
            mode="vertical"
            onClick={o => {
              if (o.key === "collect") {
                this.setState({ collectVisable: true }, () => {
                  typeof this.props.showCollect === "function" &&
                    this.props.showCollect(true);
                });
              } else if (o.key === "showURL") {
                this.setState({ urlVisible: true }, () => {
                  typeof this.props.showUrlDialog === "function" &&
                    this.props.showUrlDialog(true);
                });
              } else {
                const { onClick } = this.props;
                if (
                  o.key !== "showHelp" &&
                  o.key !== "copy" &&
                  o.key !== "paste" &&
                  o.key !== "uploadSensitive"
                ) {
                  typeof onClick === "function" && onClick(o.key);
                }
                this.onItemClick(o, datas);
              }
            }}
            id={`scroll_${scrollNum}`}
          >
            {datas.map((d, i) => {
              if (d.itemGroup && d.itemGroup.length) {
                let hasSelect = false;
                if (d.selectKey && d.selectKey.length) {
                  hasSelect = true;
                }
                const cls = classNames({
                  "wea-submenu-selected": hasSelect && true,
                  "wea-submenu-unselected": !hasSelect && true,
                  "wea-submenu-scroll": scrollHeight && true
                });
                return (
                  <SubMenu
                    ecId={`${this.props.ecId}_SubMenu@4ilit9@${d.key || i}`}
                    key={d.key || i}
                    title={
                      <span>
                        <span unselectable="on" className="wea-right-menu-icon">
                          {d.icon}
                        </span>
                        <span unselectable="on" title={d.title || d.content}>
                          {d.content}
                        </span>
                      </span>
                    }
                    disabled={d.disabled}
                    className={cls}
                    onMouseEnter={() => this.handleMouseEnter()}
                  >
                    {d.itemGroup.map(g => {
                      const {
                        key,
                        disabled,
                        icon,
                        title,
                        content,
                        itemGroupStyle
                      } = g;
                      return (
                        <Item
                          ecId={`${this.props.ecId}_Item@1esgtv@${key}`}
                          style={{
                            ...d.itemGroupStyle,
                            width: this.props.width ? this.props.width : "auto",
                            paddingLeft: hasSelect ? "20px" : null
                          }}
                          key={key}
                          disabled={disabled}
                        >
                          <li unselectable="on">
                            {d.selectKey.find(i => i === key) && (
                              <span
                                unselectable="on"
                                className="wea-right-submenu-icon"
                              >
                                <i
                                  className="icon-coms-complete"
                                  style={{ color: "#5BB5EF" }}
                                />
                              </span>
                            )}
                            <span
                              unselectable="on"
                              className="wea-right-menu-icon"
                            >
                              {icon}
                            </span>
                            <span
                              unselectable="on"
                              title={this.getMenuItemTitle(g)}
                            >
                              {content}
                            </span>
                          </li>
                        </Item>
                      );
                    })}
                  </SubMenu>
                );
              }
              return (
                <Item
                  ecId={`${this.props.ecId}_Item@pe81of@${d.key}`}
                  key={d.key || i}
                  disabled={d.disabled}
                >
                  <li unselectable="on" className="wea-right-menu-item">
                    <span unselectable="on" className="wea-right-menu-icon">
                      {d.icon}
                    </span>
                    <span unselectable="on" title={this.getMenuItemTitle(d)}>
                      {d.content}
                    </span>
                  </li>
                </Item>
              );
            })}
          </Menu>
        </WeaNewScroll>
      );
    }
    return (
      <Menu
        ecId={`${this.props.ecId}_Menu@22357n`}
        mode="vertical"
        onClick={o => {
          if (o.key === "collect") {
            this.setState({ collectVisable: true }, () => {
              typeof this.props.showCollect === "function" &&
                this.props.showCollect(true);
            });
          } else if (o.key === "showURL") {
            this.setState({ urlVisible: true }, () => {
              typeof this.props.showUrlDialog === "function" &&
                this.props.showUrlDialog(true);
            });
          } else {
            const { onClick } = this.props;
            if (
              o.key !== "showHelp" &&
              o.key !== "copy" &&
              o.key !== "paste" &&
              o.key !== "uploadSensitive"
            ) {
              typeof onClick === "function" && onClick(o.key);
            }
            this.onItemClick(o, datas);
          }
        }}
      >
        {datas.map((d, i) => {
          if (d.itemGroup && d.itemGroup.length) {
            let hasSelect = false;
            if (d.selectKey && d.selectKey.length) {
              hasSelect = true;
            }
            return (
              <SubMenu
                ecId={`${this.props.ecId}_SubMenu@6ja3sq@${d.key || i}`}
                key={d.key || i}
                title={
                  <span>
                    <span unselectable="on" className="wea-right-menu-icon">
                      {d.icon}
                    </span>
                    <span unselectable="on" title={d.title || d.content}>
                      {d.content}
                    </span>
                  </span>
                }
                disabled={d.disabled}
                className={
                  hasSelect ? "wea-submenu-selected" : "wea-submenu-unselected"
                }
              >
                {d.itemGroup.map(g => {
                  const {
                    key,
                    disabled,
                    icon,
                    title,
                    content,
                    itemGroupStyle
                  } = g;
                  return (
                    <Item
                      ecId={`${this.props.ecId}_Item@tfpo65@${key}`}
                      style={{
                        ...d.itemGroupStyle,
                        width: this.props.width ? this.props.width : "auto",
                        paddingLeft: hasSelect ? "20px" : null
                      }}
                      key={key}
                      disabled={disabled}
                    >
                      <li unselectable="on">
                        {d.selectKey.find(i => i === key) && (
                          <span
                            unselectable="on"
                            className="wea-right-submenu-icon"
                          >
                            <i
                              className="icon-coms-complete"
                              style={{ color: "#5BB5EF" }}
                            />
                          </span>
                        )}
                        <span unselectable="on" className="wea-right-menu-icon">
                          {icon}
                        </span>
                        <span unselectable="on" title={title || content}>
                          {content}
                        </span>
                      </li>
                    </Item>
                  );
                })}
              </SubMenu>
            );
          }
          return (
            <Item
              ecId={`${this.props.ecId}_Item@eu37n0`}
              key={d.key || i}
              disabled={d.disabled}
            >
              <li unselectable="on" className="wea-right-menu-item">
                <span unselectable="on" className="wea-right-menu-icon">
                  {d.icon}
                </span>
                <span unselectable="on" title={this.getMenuItemTitle(d)}>
                  {d.content}
                </span>
              </li>
            </Item>
          );
        })}
      </Menu>
    );
  };
  getCollect = () => (
    <WeaCollect
      ecId={`${this.props.ecId}_WeaCollect@stnix4`}
      {...this.props.collectParams}
      visible={this.state.collectVisable}
      onClose={() => this.setState({ collectVisable: false })}
    />
  );
  getUrl = () => (
    <ShowUrl
      ecId={`${this.props.ecId}_ShowUrl@ywxvao`}
      urlVisible={this.state.urlVisible}
      maskClose={this.state.maskClose}
      onCancel={() => this.setState({ urlVisible: false })}
    />
  );
  handleMouseEnter = () => {
    setTimeout(() => {
      const scrollCom = document.getElementsByClassName("wea-submenu-scroll");
      for (let i = 0, len = scrollCom.length; i < len; i++) {
        const _top = scrollCom[i].offsetTop;
        const _scrollH = scrollCom[i].parentElement.parentElement.scrollTop;
        scrollCom[i].lastElementChild.style.top = `${_top - _scrollH}px`;
      }
    }, 100);
  };
  onSave = params => {
    WeaTools.callApi("/api/sensitive/saveSensitiveWordApprove", "POST", {
      ...params
    }).then(res => {
      if (res.api_status) {
      }
    });
  };
  changeVisible = visible => {
    this.setState({ sensitiveVisible: visible });
  };
  render() {
    const {
      datas: _datas,
      collectParams,
      inDialog = false,
      helpParams,
      activeElement,
      selectionStart,
      selectionEnd,
      isRM,
      isScroll,
      scrollNum,
      showReport,
      showUrlItem: showUrlItemProps
    } = this.props;
    const { sensitiveVisible, sensitiveWordFeedback } = this.state;
    // const { showUrlItem } = this.state;
    const showUrlItem =
      ls.getJSONObj("theme-account") &&
      ls.getJSONObj("theme-account").userid === "1";
    // localStorage.setItem(showCopyAndPaste, { showCopyAndPaste: 1 })
    const showHelp = ls.getJSONObj("showHelp") || { showHelp: "" };
    // const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    // const isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    // let isIE =
    //   userAgent.indexOf("compatible") > -1 &&
    //   userAgent.indexOf("MSIE") > -1 &&
    //   !isOpera;
    let showCopyAndPaste = {
      showCopyAndPaste: ""
    };
    let isIE = false;
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      isIE = true;
    }
    // const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    // reIE.test(userAgent);
    // const fIEVersion = parseFloat(RegExp["$1"]);
    // if (fIEVersion == 7) {
    //   isIE = true;
    // } else if (fIEVersion == 8) {
    //   isIE = true;
    // } else if (fIEVersion == 9) {
    //   isIE = true;
    // } else if (fIEVersion == 10) {
    //   isIE = true;
    // } else if (fIEVersion == 11) {
    //   isIE = true;
    // }
    // if (isIE) {
    showCopyAndPaste = ls.getJSONObj("showCopyAndPaste") || {
      showCopyAndPaste: ""
    };
    if (!isRM) {
      showCopyAndPaste = { showCopyAndPaste: "" };
    }
    // }
    const other = [];
    if (
      showReport &&
      (window.localStorage.sensitiveWordFeedback == 1 ||
        sensitiveWordFeedback == 1)
    ) {
      other.push({
        key: "uploadSensitive",
        icon: <i className="Icon-coms03-Sensitive-words" />,
        content: getLabel(531499, "上报敏感词"),
        onClick: () => {
          if (typeof window.reportSensitiveWord === "function") {
            window.reportSensitiveWord();
          }
        }
      });
    }
    collectParams &&
      other.push({
        key: "collect",
        icon: <i className="icon-coms-Collection" />,
        content: getLabel("28111", "收藏")
      });
    (showHelp.showHelp === "true" ||
      (helpParams.helpDocid && helpParams.helpDocid !== "")) &&
      other.push({
        key: "showHelp",
        icon: <i className="icon-coms-help" />,
        content: getLabel(275, "帮助"),
        onClick: () => {
          let url = window.location.hash,
            tabKeys = window.tabKeys || [],
            urlParamsIndex = 0;
          url = url.replace("#/", "");
          url = url.replace("main/", "");
          url = url.slice(0, url.indexOf("?")); // 去掉_key
          if (startsWith(url, "portal")) {
            inDialog ? (url = "portal/menu") : (url = "portal/summary");
          }
          Array.isArray(tabKeys) &&
            !isEmpty(tabKeys) &&
            tabKeys.forEach((v, l) => {
              const key = v.slice(v.indexOf("_key:") + 5, v.indexOf("_name:")),
                name = v.slice(v.indexOf("_name:") + 6);
              if (name !== "") {
                url += urlParamsIndex === 0 ? "?" : "&";
                // url += `key${urlParamsIndex}=${key},name${urlParamsIndex}=${name}`;
                url += `key${urlParamsIndex}=${key}`;
                urlParamsIndex++;
              }
            });
          // const Base64 = WeaTools.Base64;
          let src = `https://www.e-cology.com.cn/formmode/apps/ktree/ktreeHelpE9.jsp?pathKey=${Base64.encode(
            url
          )}`;
          !isEmpty(Object.keys(helpParams)) &&
            (src = `/spa/document/index.jsp?id=${helpParams.helpDocid}`);
          const userLanguage = window.e9_locale
            ? window.e9_locale.userLanguage
            : 7;
          window.open(`${src}&lang=${userLanguage}`);
        }
      });
    showCopyAndPaste.showCopyAndPaste === "1" &&
      other.push(
        {
          key: "copy",
          icon: <i className="icon-coms-copy" />,
          content: `${getLabel("77", "复制")}(Ctrl+C)`,
          onClick: () => {
            document.execCommand("copy");
          }
        },
        {
          key: "paste",
          icon: <i className="icon-coms-Paste" />,
          content: `${getLabel("16180", "粘贴")}(Ctrl+V)`,
          onClick: () => {
            if (window.clipboardData) {
              const text = window.clipboardData.getData("Text") || "";
              const dom = document.querySelector("input:focus,textarea:focus");
              if (dom) {
                const start = dom.selectionStart;
                const end = dom.selectionEnd;
                const domText = dom.value;
                dom.value =
                  domText.substring(0, start) + text + domText.substring(end);
                if (
                  dom.className.indexOf("ant-input") !== -1 ||
                  dom.className === "ant-select-search__field" ||
                  dom.parentNode.parentNode.className.indexOf(
                    "wea-input-focus"
                  ) !== -1 ||
                  dom.parentNode.parentNode.className.indexOf(
                    "wea-textarea-normal"
                  ) !== -1
                ) {
                  // 文本框
                  dom.pasteValue =
                    domText.substring(0, start) + text + domText.substring(end);
                  dom.click(); // 手动触发文本框中input点击事件
                }
              }
            } else {
              // 流程只读库需要读到完整组件库 尴尬 如果完整未加载完还不会提示了
              const doConfirm =
                window.antd && window.antd.Modal
                  ? window.antd.Modal.confirm
                  : confirm;
              const modal = doConfirm({
                title: getLabel(132010, "信息提示"),
                content: getLabel(
                  531950,
                  "非IE内核浏览器无法粘贴，请使用键盘快捷键（Ctrl+V）来完成。"
                ),
                okCancel: false,
                okText: getLabel("83446", "确定"),
                onOk: () => {
                  if (activeElement) {
                    if (this.pasteAuto) clearTimeout(this.pasteAuto);
                    activeElement.focus();
                    setTimeout(() => {
                      activeElement.setSelectionRange(
                        selectionStart,
                        selectionEnd
                      );
                    }, 0);
                  }
                },
                onCancel: () => {
                  if (activeElement) {
                    if (this.pasteAuto) clearTimeout(this.pasteAuto);
                    activeElement.focus();
                    setTimeout(() => {
                      activeElement.setSelectionRange(
                        selectionStart,
                        selectionEnd
                      );
                    }, 0);
                  }
                }
              });
              this.pasteAuto = setTimeout(() => {
                if (modal) {
                  modal.destroy();
                  if (activeElement) {
                    activeElement.focus();
                    setTimeout(() => {
                      activeElement.setSelectionRange(
                        selectionStart,
                        selectionEnd
                      );
                    }, 0);
                  }
                }
                if (this.pasteAuto) clearTimeout(this.pasteAuto);
              }, 6000);
              return false;
            }
          }
        }
      );
    (showUrlItem || showUrlItemProps) &&
      other.push({
        key: "showURL",
        icon: <i className="icon-coms-PageAddress" />,
        content: getLabel("21682", "显示页面地址")
      });

    const datas = _datas.concat(other);
    if (typeof this.props.customMenu === "function") {
      this.props.customMenu(datas);
    }
    this.isEmpty = datas.length === 0;
    if (datas.length === 0) return null;
    const list = [
      <iframe className="wea-right-menu-iframe" />,
      <div className="wea-right-menu-icon-background" />,
      this.getMenu(datas, scrollNum, isScroll)
    ];
    collectParams && list.push(this.getCollect());
    showUrlItem && list.push(this.getUrl());
    return list;
  }
}

export default RightMenu;



// WEBPACK FOOTER //
// ./ecology9/wea-right-menu/RightMenu.js